<template>
    <div class="page">
        <el-form v-if="send" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
            <el-form-item label="">
                <el-input v-model="queryForm.deptName" placeholder="部门名称"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="checkState = 'check'">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" @click="checkState = 'reset'">重置</el-button>
            </el-form-item>
        </el-form>
        <DeptListTable :data="this.data" @send="getData" :queryForm="queryForm" :checkState="checkState" :areaList="areaList" @resetCheckState="resetCheckState"/>
    </div>
</template>

<script>
import DeptListTable from '@/components/organization/DeptListTable.vue';

export default {
    components: {
        DeptListTable
    },
    data() {
        return {
            queryForm: {
                deptName: ''
            },
            send: '',
            areaList: [],
            checkState: '',
            data: '',
        };
    },
    created() {},
    methods: {
        getData(data){
            this.send = data;
        },
        resetCheckState() {
            if (this.checkState == 'reset') {
                this.queryForm = {
                    deptName: ''
                };
            }
            this.checkState = '';
        }
    }
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  button{
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
